import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";
import axios from "axios";

export default function DataTable_Component({
  apidata,
  columns,
  searchBy,
  applyFiltersExternally,
  totalRows,
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,
  clientFilter,
  setClientFilter,
  dataFilter,
  setDataFilter,
  statusCounts,
  statusFilter,
  setStatusFilter,
  date,
  setDate,
}) {
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [clients, setClients] = useState([]);
  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const token = localStorage.getItem("token");
        const userRole = localStorage.getItem("userRole");

        let apiUrl = "";

        if (userRole === "superadmin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/clients`;
        } else if (userRole === "admin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/clients`;
        }

        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setClients(response.data.clients || []);
      } catch (err) {
        console.error("Error fetching clients", err);
      }
    };

    fetchClients();
  }, []);

  const applyFilters = () => {
    setCurrentPage(1);

    if (applyFiltersExternally) {
      applyFiltersExternally(
        date,
        1,
        rowsPerPage,
        clientFilter,
        dataFilter,
        statusFilter,
      );
    }

    setShowFilterModal(false);
  };

  const removeFilters = () => {
    setClientFilter("");
    setDate(today);

    if (applyFiltersExternally) {
      applyFiltersExternally(today, 1, rowsPerPage, "");
    }

    setShowFilterModal(false);
  };
  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by ${searchBy}`}
            className="form-control"
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
          />
        </div>
        {/* <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div> */}
        <div className="col-md-9 mb-2 d-flex gap-2 flex-wrap">
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>

          <button
            className={`btn ${
              statusFilter === "EARLY" ? "btn-warning" : "btn-outline-warning"
            }`}
            // // onClick={() =>
            // //   setStatusFilter(statusFilter === "EARLY" ? "" : "EARLY")
            // // }
            // onClick={() => {
            //   console.log("EARLY CLICKED");
            //   setStatusFilter(statusFilter === "EARLY" ? "" : "EARLY");
            // }}
          >
            <b> EARLY ({statusCounts?.EARLY || 0}) </b>
          </button>

          <button
            className={`btn ${
              statusFilter === "ON_TIME" ? "btn-success" : "btn-outline-success"
            }`}
            // // onClick={() =>
            // //   setStatusFilter(statusFilter === "ON_TIME" ? "" : "ON_TIME")
            // // }
            // onClick={() => {
            //   console.log("ON_TIME CLICKED");
            //   setStatusFilter(statusFilter === "ON_TIME" ? "" : "ON_TIME");
            // }}
          >
            <b> ON TIME ({statusCounts?.ON_TIME || 0})</b>
          </button>

          <button
            className={`btn ${
              statusFilter === "LATE" ? "btn-danger" : "btn-outline-danger"
            }`}
            // // onClick={() =>
            // //   setStatusFilter(statusFilter === "LATE" ? "" : "LATE")
            // // }
            // onClick={() => {
            //   console.log("LATE CLICKED");
            //   setStatusFilter(statusFilter === "LATE" ? "" : "LATE");
            // }}
          >
            <b> LATE ({statusCounts?.LATE || 0}) </b>
          </button>

          <button
            className={`btn ${
              statusFilter === "TOTAL" ? "btn-warning" : "btn-outline-warning"
            }`}
            // // onClick={() =>
            // //   setStatusFilter(statusFilter === "EARLY" ? "" : "EARLY")
            // // }
            // onClick={() => {
            //   console.log("EARLY CLICKED");
            //   setStatusFilter(statusFilter === "EARLY" ? "" : "EARLY");
            // }}
          >
            <b>TOTAL ({statusCounts?.TOTAL || 0}) </b>
          </button>

          {/* {statusFilter && (
            <button
              className="btn btn-secondary"
              onClick={() => setStatusFilter("")}
            >
              Clear
            </button>
          )} */}
        </div>
      </div>
      <DataTable
        columns={columns}
        data={apidata}
        pagination
        fixedHeader
        highlightOnHover
        responsive
        paginationServer
        paginationTotalRows={totalRows}
        paginationPerPage={rowsPerPage}
        paginationRowsPerPageOptions={[5, 10, 15, 20]}
        onChangePage={(page) => {
          setCurrentPage(page);
        }}
        onChangeRowsPerPage={(newPerPage) => {
          setRowsPerPage(newPerPage);
        }}
      />

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        clients={clients}
        clientFilter={clientFilter}
        setClientFilter={setClientFilter}
        date={date}
        setDate={setDate}
      />
    </div>
  );
}
